import React from "react";
import { useRecoilValue } from "recoil";
import { useGetDefinitions } from "../../api/useDictionary";
import { languageState } from "../../recoil/language";
import { SearchOverflow } from "../../types/SearchOverflow";
import SearchResults from "./SearchResults";

interface DictionaryApiProps {
  readonly word: string;
  readonly sendRequest: boolean;
  readonly setDataFetched: (isFetched: boolean) => void;
  readonly addSearchOverflow: (overflow: SearchOverflow) => void;
  readonly selectedDefinitions: Array<string>;
  readonly setSelectedDefinitions: (selectedDefintions: Array<string>) => void;
}

const DictionaryApi: React.FC<DictionaryApiProps> = ({
  word,
  sendRequest,
  setDataFetched,
  addSearchOverflow,
  selectedDefinitions,
  setSelectedDefinitions,
}) => {
  const language = useRecoilValue(languageState);
  const getDefinitions = useGetDefinitions(word, language, sendRequest);

  React.useEffect(() => setDataFetched(getDefinitions.isFetched), [
    setDataFetched,
    getDefinitions.isFetched,
  ]);

  return (
    <SearchResults
      searchType="definitions"
      searchResults={getDefinitions.data}
      word={word}
      addSearchOverflow={addSearchOverflow}
      selectedSearchResults={selectedDefinitions}
      setSelectedSearchResults={setSelectedDefinitions}
    />
  );
};

export default React.memo(DictionaryApi);
